import { Environment } from '../../env/Environment';
import { Typography } from '../primitives';
import { Trans } from '@rpi/i18n';

export const CartTermsAndConditions = () => {
  return (
    <Typography variant="body" className="text-center">
      <Trans
        i18nKey="route.cart.legal"
        components={{
          'shipping-link': (
            <a
              aria-label="Shipping Link"
              href={Environment.LINK.BLURB_SHIPPING}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </Typography>
  );
};
